import {axiosReqGet, axiosReqOther} from "./config";
import { store } from '../store/store';

const USER_TOKEN = store.getState().authentication.user;

export const Location = {
    getAutocompleteLocation
}

function getAutocompleteLocation(post){
    const url = 'location/get-locations.json';
    return axiosReqOther(url, post, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        return err; 
    });
}

export default Location;